import { ApiService } from "@/api";

export const getQuestionVersion = () => {
  return ApiService.baseAction(`question/version/latest`, {}, "GET");
};
